import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-polling-data',
  templateUrl: './polling-data.component.html',
  styleUrls: ['./polling-data.component.scss']
})
export class PollingDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/polling-data/polling-data.component.ts